import {
  BadgeImg,
  BadgeLogo,
  BadgeLogoBox,
  BadgeContainer
} from "./Footer.styles";

// A&M Premium Partner badge with the company logo in its empty panel
// (Asana 1213410886347834); `badge` comes from getPartnerBadge.
export const PartnerBadge = ({ badge, logoSrc, logoAlt }) => {
  const { left, top, width, height } = badge.logoBox;
  return (
    <BadgeContainer data-testid="partner-badge">
      <BadgeImg src={badge.src} alt="A&M Unternehmerberatung Premium-Partner" />
      <BadgeLogoBox
        style={{
          left: `${left}%`,
          top: `${top}%`,
          width: `${width}%`,
          height: `${height}%`
        }}
      >
        <BadgeLogo src={logoSrc} alt={logoAlt || ""} />
      </BadgeLogoBox>
    </BadgeContainer>
  );
};
